// utils/navigationHelper.js

/**
 * Detecta si la aplicación está corriendo dentro de un iframe
 * @returns {boolean} true si está en iframe, false si no
 */
export const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    // Si hay un error de acceso, probablemente estamos en un iframe con restricciones
    return true;
  }
};

/**
 * Obtiene la ruta de login correcta según el contexto
 * @returns {string} '/loginovi' si está en iframe, '/login' si no
 */
export const getLoginRoute = () => {
  return isInIframe() ? '/loginovi' : '/login';
};

/**
 * Redirige a la página de login correcta según el contexto
 */
export const redirectToLogin = () => {
  const loginRoute = getLoginRoute();
  console.log(`🔄 Redirigiendo a ${loginRoute} (iframe: ${isInIframe()})`);
  window.location.href = loginRoute;
};
